module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"loading":"加载中"},"en":{"loading":"Loading"},"jp":{"loading":"読み込み中"},"fr":{"loading":"Chargement en cours"},"de":{"loading":"Beladen"},"es":{"loading":"Cargando"},"pt":{"loading":"Carregando"},"it":{"loading":"Caricamento in corso"},"tw":{"loading":"正在為您加載"},"kr":{"loading":"로드"}}')
  delete Component.options._Ctor
}
